const routes = {
  home: '/',
  register: '/register',
  login: '/login',
  todos: '/todos',
  singleTodos: '/todos/:todosId',
  account: '/account',
};

export default routes;
